import { City } from "@components/organisms/CitySelectionModal/City.types";
import { CITY_URL, CITY_URL_SERVER } from "./endpoints";
import { defaultCity } from "@constants/cities";

const getCachedCities = () => {
    if (!(globalThis as any).cityCache) {
        (globalThis as any).cityCache = null;
        (globalThis as any).cityCacheTimestamp = 0;
    }
    const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes
    const now = Date.now();
    if (
        (globalThis as any).cityCache &&
        now - (globalThis as any).cityCacheTimestamp < CACHE_DURATION
    ) {
        return (globalThis as any).cityCache;
    }
}

const setCachedCities = (cities: City[]) => {
    (globalThis as any).cityCache = cities;
    (globalThis as any).cityCacheTimestamp = Date.now();
}

export const getCities = async () => {
    try {
        const cachedCities = getCachedCities();
        if (cachedCities) {
            console.log("Using cached cities");
            return getLiveCities(cachedCities);
        }

        const res = await fetch(CITY_URL);
        if (!res.ok) {
            throw new Error(`Failed to fetch cities: ${res.statusText}`);
        }
        const data: City[] = await res.json();
        setCachedCities(data);
        return getLiveCities(data)
    } catch (error) {
        console.error(error);
        return [];
    }
};

export async function getSelectedCityDetails(cityName: string): Promise<City> {
    try {
        const cachedCities = getCachedCities();
        if (cachedCities) {
            console.log("Using cached cities");
            return getSelectedCityBySlug(cachedCities, cityName);
        }
        const res = await fetch(CITY_URL_SERVER);
        if (!res.ok) {
            throw new Error(`Failed to fetch cities: ${res.statusText}`);
        }
        const data: City[] = await res.json();
        setCachedCities(data);
        return getSelectedCityBySlug(data, cityName);
    } catch (error) {
        // Optionally log the error
        console.error(error);
        return defaultCity;
    }
};

function getSelectedCityBySlug(cities: City[], cityName: string) {
    return cities.find((city: City) => city.city_slug === cityName) || defaultCity;
}

function getLiveCities(cities: City[]) {
    return cities.filter(
        (city) => city.city_config?.is_live && city.city_config?.logo_image
    );
}